import api from "@/Utils/api";

const getFields = () => api.get("fields");
const saveCustomField = (id, request) => api.post(`productCatalog/fields/${id}`, request);

export {
    getFields,
    saveCustomField,
};
